import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

@Component({
  selector: 'app-site-summary-details-dialog',
  templateUrl: './site-summary-details-dialog.component.html',
  styleUrls: ['./site-summary-details-dialog.component.css'],
  standalone: false
})
export class SiteSummaryDetailsDialogComponent implements OnInit {
  displayedColumns: string[] = ['parameter', 'value'];
  dataSource: MatTableDataSource<{ parameter: string; value: number }>;
  summaryData: any;
  siteName: string;
  potentialId: any;
  accountId: any;

  constructor(
    public dialogRef: MatDialogRef<SiteSummaryDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {
    this.summaryData = data?.summaryData || {};
    this.siteName = data?.siteName || '';
    this.potentialId = data?.potentialId || data?.element?.potentialId;
    this.accountId = data?.accountId || data?.element?.accountId;
  }

  ngOnInit(): void {
    const tableData: { parameter: string; value: number }[] = [];
    
    if (this.summaryData) {
      tableData.push({ parameter: 'Human Review Count', value: this.summaryData.humanReviewCount || 0 });
      tableData.push({ parameter: 'Activity Count', value: this.summaryData.activityCount || 0 });
      tableData.push({ parameter: 'Threat Count', value: this.summaryData.threatCount || 0 });
      tableData.push({ parameter: 'Total Crime Count', value: this.summaryData.totalCrimeCount || 0 });
      tableData.push({ parameter: 'PC/SC Called', value: this.summaryData.pcScCalled || 0 });
      tableData.push({ parameter: 'Police Notified', value: this.summaryData.policeNotified || 0 });
      tableData.push({ parameter: 'Alarm Count', value: this.summaryData.alarmCount || 0 });
      tableData.push({ parameter: 'Total Count', value: this.getTotalCount() });
    }
    
    this.dataSource = new MatTableDataSource(tableData);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  navigateToDetailsPage(): void {
    this.dialogRef.close();
    const id = this.potentialId || this.accountId;
    if (id) {
      this.router.navigate(['/cp/summary-details', id]);
    }
  }

  getTotalCount(): number {
    if (!this.summaryData) return 0;
    return (this.summaryData.humanReviewCount || 0) +
           (this.summaryData.activityCount || 0) +
           (this.summaryData.threatCount || 0) +
           (this.summaryData.totalCrimeCount || 0) +
           (this.summaryData.pcScCalled || 0) +
           (this.summaryData.policeNotified || 0) +
           (this.summaryData.alarmCount || 0);
  }
}

